import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './app.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  fileToUpload: File = null;

  constructor(private serv: AppService, private router: Router) {
  
   }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
}


  ngOnInit(): void {
    this.serv.isLoggedIn$.subscribe(x => {
      //
      if (!x) {
        console.log("!x main")
        this.router.navigate(['/'])
      }
    })
  }
/*
  uploadFileToActivity() {
    this.serv.postFile(this.fileToUpload).subscribe(data => {
      // do something, if upload success
      }, error => {
        console.log(error);
      });
  }
*/
}
